/* eslint-disable import/order */
/* eslint no-use-before-define: 0 */
export const createParagraph = text => ({
  type: "paragraph",
  children: [{ text }]
});
